export enum Season {
  SummerAndWinter = 0,
  Summer = 1,
  Winter = 2
}
